module.exports = __webpack_public_path__ + "static/media/fs-details.7044e359.svg";